import Vue from 'vue'
import Vuex from 'vuex'
import user from './modules/user.js'
import permission from './modules/permission.js'
import tagsView from './modules/tagsView.js'
import breadcrubs from './modules/breadcrub.js'
import uiPermisson from './modules/uiPermisson.js'
import audit from './modules/audit'
import match from './modules/match'
import onside from './modules/onside'
Vue.use(Vuex)
// 过滤左侧导航
function filterLayoutRoutes (routes) {
  const res = []
  routes.forEach(ele => {
    const tmp = { ...ele }
    if (tmp.hidden === false) {
      if (tmp.children) {
        tmp.children = filterLayoutRoutes(tmp.children)
      }
      res.push(tmp)
    }
  })
  return res
}
// 侧边栏权限
// const containerSlider = ['manageSysteam', 'material', 'verify']
// 面包屑权限
const containerBread = ['verify']
export default new Vuex.Store({
  state: {
    slideToggle: false,
    image: '', // 上传的会员头像图片路径
    ossUrl: '', // oss图片资源访问路径
    matchResult: {
      groupList: [], // 比赛分组数据
      awardList: [] // 比赛获奖数据
    },
    numberOfMatch: 1, // 比赛名次
    topTitles: []
  },
  getters: {
    getImage (state) {
      return state.image
    },
    getOssUrl (state) {
      return state.ossUrl
    },
    getMatchResult (state) {
      return state.matchResult
    },
    getNumberOfMatch (state) {
      return state.numberOfMatch
    },
    visitedViews (state) {
      return state.tagsView.visitedViews
    },
    cachedViews (state) {
      return state.tagsView.cachedViews
    },
    permissionRoutes (state) {
      if (!state.permission.routes) {
        return []
      }
      let layoutRoutes = state.permission.routes
      let layoutChildren = []
      let resultLayoutRoutes = []
      layoutChildren = filterLayoutRoutes(layoutRoutes)
      // 排除子路由为空的清空
      resultLayoutRoutes = layoutChildren.filter(route => {
        if (route.children && route.children.length > 0) {
          return route
        } else {
          return false
        }
      })
      const result = []
      resultLayoutRoutes.forEach(item => {
        if (item.children.length === 1) {
          result.push(item.children[0])
        } else {
          result.push(item)
        }
      })
      return result
    },
    shouldShowHeader (state) {
      let type = state.uiPermisson.sysType
      return containerBread.indexOf(type) >= 0
    },
    shouldShowSlider (state) {
      const perms = state.uiPermisson.sysType
      return perms.length > 1
    },
    shouldShowHandleBook (state) {
      return true
    }
  },
  mutations: {
    changeSlide (state) {
      state.slideToggle = !state.slideToggle
    },
    changeImage (state, newImage) {
      state.image = newImage
    },
    changeOssUrl (state, url) {
      state.ossUrl = url
    },
    changeMatchResult (state, data) {
      state.matchResult = data
    },
    changeNumberOfMatch (state, data) {
      state.numberOfMatch = data
    },
    changeTopTitles (state, data) {
      state.topTitles = data
    }
  },
  actions: {
    commitChangeSlide (content) {
      content.commit('changeSlide')
    },
    commitChangeImage ({ commit }, newImage) {
      commit('changeImage', newImage)
    },
    commitChangeOssUrl ({ commit }, url) {
      commit('changeOssUrl', url)
    },
    commitChangeMatchResult ({ commit }, data) {
      commit('changeMatchResult', data)
    },
    commitChangeNumberOfMatch ({ commit }, data) {
      commit('changeNumberOfMatch', data)
    },
    commitChangeTopTitles ({ commit }, data) {
      commit('changeTopTitles', data)
    }
  },
  modules: {
    user,
    permission,
    tagsView,
    breadcrubs,
    uiPermisson,
    audit,
    match,
    onside
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js